import type { TrackerGridHandle } from "./TrackerGridHandle";

let handle: TrackerGridHandle | null = null;

export function setTrackerGrid(next: TrackerGridHandle | null): void {
  handle = next;
}

export function getTrackerGrid(): TrackerGridHandle | null {
  return handle;
}
